import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";

import axios from "../helpers/axios";
import Layout from "../components/global/Layout";
import PartTable from "../components/parts/PartTable";
import SyncButton from "../backorders/components/SyncButton";

const BackOrder = () => {
  const [showNotification, setShowNotification] = useState(false);
  const { document } = useParams();

  const [count, setCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [is404, set404] = useState(false);
  const [data, setData] = useState(null);

  const [backorder, setBackorder] = useState(null);

  const company = process.env.REACT_APP_CODE_COMPANY;
  const dbs_host = process.env.REACT_APP_DBS_HOST;


  const shareLinkReferred = () => {
    const { protocol, host } = window.location;
    const uri = `${protocol}//${host}/order/${document}`;

    if (navigator.share) {
      navigator
        .share({
          title: `Rastreo de ${uri}`,
          text: `Sistema de rastreo de pedidos ${company}`,
          url: uri,
        })
        .then(() => {
          console.log("Successful share");
        })
        .catch((error) => {
          console.log("Error sharing", error);
        });
    } else {
      if (!navigator.clipboard) {
        // fallbackCopyTextToClipboard("http://localhost:3000/order/" + document);
        // console.log("Failed copied");
        return;
      }
      navigator.clipboard.writeText(uri).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1500);
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    }
  };

  const fetchDocument = () => {
    setLoading(true);

    axios
      .get(`api/backorders/${document}/`)
      .then(({ status, data }) => {
        if (status === 200) {
          setBackorder(data);
          setCount(count+1)
        } else {
          setBackorder(null);
          set404(true);
        }
      })
      .catch(() => {
        setBackorder(null);
        set404(true);
      })
      .then(() => {
        setLoading(false);
      });

    /* development purposes only */
    axios
      .post(
        `${dbs_host}dbs/public/api/v1/getBackorder?company=${company}&document=${document}`
      )
      .then(({ status, data }) => {
        if (status === 200 && data.message === "Success") {
          setData(data.payload);
        }
      });
      
  };

  useEffect(() => {
    fetchDocument();
  }, [document]);

  useEffect(() =>{
    statusC();
  });
  
  const statusC = ()=>{
    if (data){
      const rfdcno = data.children.map((datos)=>{
        if (datos.docsu==="C" ){
          return datos.rfdcno
        }
      })
      const rfdcnoFilter = rfdcno.filter((filtro) => filtro);
      if (rfdcnoFilter.length>0){
        for (let index = 0; index < rfdcnoFilter.length; index++) {
          const parts = backorder.parts.map((part)=>{
            if (part.rfdcno === rfdcnoFilter[index] && part.status!==80){
              axios
              .patch(`/api/parts/${part.id}/`, {
                'status': 80,
                'docsu': 'C'
              })
              part.status=80
              part.docsu='C'
            }
            return part
        })
        backorder.parts = parts
        setBackorder(backorder)
        }
      }
    }
  }
  
  let content = null;
  if (isLoading) {
    content = (
      <section className="hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">Cargando</h1>
            <h2 className="subtitle">
              Obteniendo información desde el servidor
            </h2>
          </div>
        </div>
      </section>
    );
  } else if (is404) {
    content = (
      <section className="hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">Error 404</h1>
            <h2 className="subtitle">
              El documento buscado no se pudo ser localizado
            </h2>
          </div>
        </div>
      </section>
    );
  } else if (backorder !== null) {
    content = (
      <div
        className="container"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "3rem",
        }}
      >
        <div className="card" style={{ marginBottom: "1rem" }}>
          <div className="level has-text-grey" style={{ lineHeight: "70px" }}>
            <div className="level-item has-text-centered">
              <div>
                <b>Documento:</b> {backorder.rfdcno}
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div>
                <b>Fecha de creación:</b> {backorder.endt8}
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div title={backorder.cuname}>
                <b>Cliente:</b> {backorder.cuno}
              </div>
            </div>
            <div className="level-item has-text-centered">
              <div>
                <b>Vendedor:</b> {backorder.slsrep}
              </div>
            </div>
            <div className="level-item has-text-centered">
              <span
                className="icon"
                style={{ cursor: "pointer" }}
                onClick={shareLinkReferred}
              >
                <FontAwesomeIcon icon={["fas", "share-alt"]} />
              </span>
            </div>
          </div>
        </div>
        {count===0?fetchDocument():null}
        <PartTable
          parts={backorder.parts}
          actions={[
            <SyncButton backorder={backorder} onSync={() => fetchDocument()} />,
          ]}
          onChange={() => {
            fetchDocument();
          }}
        />
      </div>
    );
  }

  
  return (
    <Layout>
      <div>
        {showNotification ? (
          <div
            className="notification is-success"
            style={{
              position: "absolute",
              top: "40px",
              right: "10px",
              color: "white",
              zIndex: "99",
              padding: "5px",
            }}
          >
            Url copiado al portapapeles
          </div>
        ) : null}
        {content}
        <br />
        <br />
        {data ? (
          <div className="container">
            <div className="card">
              <pre>{JSON.stringify(data, null, " ")}</pre>
            </div>
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default BackOrder;
